import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../contexts/AuthContext';
import { bridgeAPI } from '../utils/whatsappBridge';

export function useBridgeAccess() {
  const { user, tenant } = useAuth();
  // Auth responses expose the active tenant separately from the user.
  const tenantId = tenant?.id ?? user?.tenant_id;
  return useQuery({ queryKey: ['wa-access', tenantId, user?.id], queryFn: bridgeAPI.access,
    enabled: !!user && user.role !== 'cliente' && !!tenantId, staleTime: 30000, refetchInterval: 30000 });
}
